module.exports = __webpack_public_path__ + "static/media/excel.b42237b5.png";